import {handleAssetsUrl} from './comFunc'

class SoundPlayHandle {
  constructor() {
    this.currentTime = 0;
    this.totalTime = 10;
    this.isPlay = false;
    this.musicVolume = 100;
    this.dubbingVolume = 100;
    this.music = [];
    this.musicPlayData = [];
    this.dubbing = [];
    this.dubbingPlayData = [];
    this.startTime = 0;
    this.nowTime = 0;
    this.startNode = 0;
    this.playFrame = null;
    this.musicLoop = false;
    this.reset = false;
  }
  loopMusic (music) {
    music = JSON.parse(JSON.stringify(music));
    this.music.length = 0;
    for (let i = 0; i < music.length;i++) {
      this.music[i] = music[i];
      this.loadSound(this.music[i], 'music');
    }
    this.needUpdateMusic = true;
    this.updateMusicPlayData();
  }
  addMusic(music, index, noUpdate = false) {
    let musicObject = JSON.parse(JSON.stringify(music));
    this.loadSound(musicObject, 'music');
    if (typeof index === 'number') {
      this.music.splice(index, 0, musicObject);
    } else {
      this.music.push(musicObject);
    }
    this.updateMusicPlayData(noUpdate);
  }
  delMusic(index, noUpdate = false) {
    if(this.music[index]) {
      this.music[index].ele = null;
      this.music.splice(index, 1);
      this.updateMusicPlayData(noUpdate);
    }
  }
  updateMusic(music, index, noUpdate = false) {
    let old = this.music[index];
    if(!old) return;
    let needLoad = music.url && music.url !== old.url;
    Object.assign(old, JSON.parse(JSON.stringify(music)));
    if(needLoad) {
      if(old.ele) {
        old.load = false;
        old.ele.src = handleAssetsUrl(music.url);
        old.ele.load();
        old.ele.onloadedmetadata = () => {
          old.load = true;
          old.ele.currentTime = old.cut[0];
          old.ele.onloadedmetadata = null;
        }
      } else {
        this.loadSound(old, 'music')
      }
    }
    this.updateMusicPlayData(noUpdate);
  }
  addDubbing(dubbing, index, noUpdate = false) {
    let dubbingObject = JSON.parse(JSON.stringify(dubbing));
    this.loadSound(dubbingObject, 'dubbing');
    if (typeof index === 'number') {
      this.dubbing.splice(index, 0, dubbingObject);
    } else {
      this.dubbing.push(dubbingObject);
    }
    this.updateDubbingPlayData(noUpdate);
  }
  addDubbingGroup(dubbingArr = [], index, delNum = 1) {
    let arr = [];
    let dubbingObj = null;
    for(let i = 0; i < dubbingArr.length; i++) {
      dubbingObj = JSON.parse(JSON.stringify(dubbingArr[i]));
      this.loadSound(dubbingObj, 'dubbing')
      arr.push(dubbingObj);
    }
    if(typeof index === 'number') {
      this.dubbing.splice(index, delNum, ...arr)
    } else {
      this.dubbing.splice(this.dubbing.length, 0, ...arr)
    }
    this.updateDubbingPlayData();
  }
  delDubbing(index, noUpdate = false) {
    if(this.dubbing[index]) {
      this.dubbing[index].ele = null;
      this.dubbing.splice(index, 1);
      this.updateDubbingPlayData(noUpdate);
    }
  }
  updateDubbing(dubbing, index, noUpdate = false) {
    let old = this.dubbing[index];
    if(!old) return;
    let needLoad = dubbing.url && dubbing.url !== old.url;
    Object.assign(old, JSON.parse(JSON.stringify(dubbing)));
    if(needLoad) {
      if(old.ele) {
        old.load = false;
        old.ele.src = handleAssetsUrl(dubbing.url);
        old.ele.load();
        old.ele.onloadedmetadata = () => {
          old.load = true;
          old.ele.currentTime = old.cut[0];
          old.ele.onloadedmetadata = null;
        }
      } else {
        this.loadSound(old, 'dubbing')
      }
    }
    this.updateDubbingPlayData(noUpdate);
  }
  loadSound(sound, type) {
    sound.load = false;
    if(!sound.url) return;
    const audioEle = document.createElement('audio');
    audioEle.onerror = () => {
      sound.load = false;
      sound.ele = null;
    }
    audioEle.oncanplay = () => {
      audioEle.oncanplay = null;
      audioEle.currentTime = sound.cut[0];
    }
    audioEle.src = handleAssetsUrl(sound.url);
    audioEle.volume = this[`${type}Volume`] / 100;
    audioEle.loop = false || this.musicLoop;
    audioEle.load();
    sound.load = true;
    sound.ele = audioEle;
    sound.playing = false;
  }
  updateMusicPlayData(noUpdate = false) {
    if(noUpdate) return;
    this.musicPlayData.length = 0;
    for(let i = 0; i < this.music.length; i++) {
      this.musicPlayData.push(...this.music[i].timeSlot)
    }
  }
  updateDubbingPlayData(noUpdate = false) {
    if(noUpdate) return;
    this.dubbingPlayData.length = 0;
    for(let i = 0; i < this.dubbing.length; i++) {
      this.dubbingPlayData.push(...this.dubbing[i].timeSlot)
    }
  }
  playMusic(time, reset) {
    let num = -1,
      index = 0,
      music = null,
      leftTime = 0;
    for(let i = 0; i < this.musicPlayData.length; i++) {
      if(time > this.musicPlayData[i]) {
        num++;
        leftTime = this.musicPlayData[i];
      } else {
        break;
      }
    }
    index = parseInt(num / 2);
    for(let i = 0; i < this.music.length; i++) {
      music = this.music[i];
      if(!music.ele) continue;
      if (music.ele.loop) {
        if (music.ele.currentTime < music.cut[0] || music.ele.currentTime > music.cut[1]) {
          music.ele.currentTime = music.cut[0];
        }
      }
      if(i < index) {
        if(music.playing) {
          music.ele.pause()
          music.playing = false;
        }
      } else if(i == index) {
        if(num % 2) {
          if(music.playing) {
            music.ele.pause();
            music.playing = false;
          }
        } else {
          if(!music.playing || reset) {
            leftTime = this.musicPlayData[num] || 0;
            music.ele.currentTime = time - leftTime + music.cut[0];
            if (music.ele.loop) {
              let dur = music.cut[1] - music.cut[0];
              let nLine = Math.floor(time / dur);
              let yets = time -  dur * nLine + music.cut[0];
              music.ele.currentTime = yets;
            }
            music.ele.play();
            music.playing = true;
          }
        }
      } else {
        break;
      }
    }
  }
  pauseMusic() {
    for(let i = 0; i < this.music.length; i++) {
      if(!this.music[i].ele || !this.music[i].playing) continue;
      this.music[i].ele.pause();
      this.music[i].playing = false;
    }
  }
  playDubbing(time, reset) {
    let num = -1,
      index = 0,
      dubbing = null,
      leftTime = 0;
    for(let i = 0; i < this.dubbingPlayData.length; i++) {
      if(time > this.dubbingPlayData[i]) {
        num++;
        leftTime = this.dubbingPlayData[i];
      } else {
        break;
      }
    }
    index = parseInt(num / 2);
    for(let i = 0; i < this.dubbing.length; i++) {
      dubbing = this.dubbing[i];
      if(!dubbing.ele) continue;
      if(i < index) {
        if(dubbing.playing) {
          dubbing.ele.pause()
          dubbing.playing = false;
        }
      } else if(i == index) {
        if(num % 2) {
          if(dubbing.playing) {
            dubbing.ele.pause();
            dubbing.playing = false;
          }
        } else {
          if(!dubbing.playing || reset) {
            leftTime = this.dubbingPlayData[num] || 0;
            dubbing.ele.currentTime = time - leftTime + dubbing.cut[0];
            dubbing.ele.play();
            dubbing.playing = true;
          }
        }
      } else {
        break;
      }
    }
  }
  pauseDubbing() {
    for(let i = 0; i < this.dubbing.length; i++) {
      if(!this.dubbing[i].ele || !this.dubbing[i].playing) continue;
      this.dubbing[i].ele.pause();
      this.dubbing[i].playing = false;
    }
  }
  play(data) {
    // {isplay, time} isplay是否正在播放，time播放开始的时间（单位秒）
    if(this.isPlay) {
      if(data.isPlay) {
        this.reset = true;
      } else {
        this.pauseMusic();
        this.pauseDubbing();
        this.isPlay = false;
      }
    } else {
      if(data.isPlay) {
        this.reset = true;
        this.isPlay = true;
      }
    }
  }
  stepPlay(nowTime){
    this.playMusic(nowTime, this.reset);
    this.playDubbing(nowTime, this.reset);
    this.reset = false;
  }
  changeVolume(type, volume) {
    let sounds = this[type];
    this[`${type}Volume`] = volume;
    for(let i = 0; i < sounds.length; i++) {
      if(!sounds[i].ele) continue;
      sounds[i].ele.volume = volume / 100;
    }
  }
  changePreviewVolume(volume) {
    let dubbingVolume = this.dubbingVolume * volume / 100 / 100;
    let musicVolume = this.musicVolume * volume / 100 / 100;
    for(let i = 0; i < this.dubbing.length; i++) {
      if(!this.dubbing[i].ele) continue;
      this.dubbing[i].ele.volume = dubbingVolume;
    }
    for(let i = 0; i < this.music.length; i++) {
      if(!this.music[i].ele) continue;
      this.music[i].ele.volume = musicVolume;
    }
  }
  // 加载json
  fromJson(json) {
    this.dubbingVolume = (json.volume || {})[0] || 50;
    this.musicVolume = (json.volume || {})[1] || 50;
    this.musicLoop = !!json.musicLoop;
    let music = [],
        dubbing = [];
    this.dubbing.length = 0;
    this.music.length = 0;
    for(let i = 0; i < json.data.length; i++) {
      let sound = json.data[i];
      let obj = {
        title: sound.title,
        id: sound.resourceId,
        fileType: sound.fileType,
        url: sound.url,
        timeSlot: [...sound.timeSlot],
        cut: [...sound.cut],
        startEffect: sound.startEffect,
        endEffect: sound.endEffect
      }
      if(sound.type === 1) {
        dubbing.push(obj)
      }else if(sound.type === 2) {
        music.push(obj)
      }
    }
    music.sort(function(a, b) {
      return a.timeSlot[0] - b.timeSlot[0];
    })
    dubbing.sort(function(a, b) {
      return a.timeSlot[0] - b.timeSlot[0];
    })
    music.forEach(sound => {
      this.addMusic(sound, undefined, true)
    })
    dubbing.forEach(sound => {
      this.addDubbing(sound, undefined, true)
    })
    this.updateMusicPlayData();
    this.updateDubbingPlayData();
  }
}

export default SoundPlayHandle;



// WEBPACK FOOTER //
// ./src/components/draftPreview/soundPlay.js